module.exports = __webpack_public_path__ + "static/media/error_404_img.54f86491.png";